module.exports = __webpack_public_path__ + "assets/waf.1244d362.svg";